import Page from 'flarum/common/components/Page';
import IndexPage from 'flarum/forum/components/IndexPage';
import CommentPost from 'flarum/forum/components/CommentPost';
import PostStreamState from 'flarum/forum/states/PostStreamState';
import BlogPostController from '../components/BlogPostController';
import BlogItemSidebar from '../components/BlogItemSidebar/BlogItemSidebar';
import Link from 'flarum/common/components/Link';
import BlogOverview from './BlogOverview';
import fullTime from 'flarum/common/helpers/fullTime';
import ArticleSubscription from '../components/ArticleSubscription';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
import icon from '../../common/helpers/icon';
import app from 'flarum/forum/app';
export default class BlogItem extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle(app.translator.trans('v17development-flarum-blog.forum.blog'));

    // Send history push
    app.history.push('blogArticle');
    this.bodyClass = 'BlogItemPage';

    // near: post number (nem post id!)
    this.near = parseInt(m.route.param('near'), 10) || null;
    this.loading = true;
    this.found = false;
    this.article = null;
    this.stream = null;
    this.PostStream = null;
    flarum.reg.asyncModuleImport('flarum/forum/components/PostStream').then(module => {
      this.PostStream = module.default;
      m.redraw();
    }).catch(() => m.redraw());
    this.loadBlogItem();
  }

  /**
   * Betölti a discussion-t (blog cikket). A near postokat NEM itt "varázsoljuk" a discussion API-ból,
   * hanem külön /api/posts callal.
   */
  loadBlogItem() {
    const preload = app.preloadedApiDocument();
    if (preload) {
      // preloadból jön a discussion
      setTimeout(() => this.show(preload), 0);
      m.redraw();
      return;
    }
    const id = m.route.param('id').split('-')[0];

    // (opcionális) include itt maradhat minimálon
    app.store.find('discussions', id).then(discussion => this.show(discussion)).catch(() => m.redraw());
    m.redraw();
  }

  /**
   * Töltsük be a near körüli post csomagot a POSTS endpointon.
   * Ez biztosítja, hogy Ctrl+F5 után is legyen "hova ugrani".
   */
  preloadNearPosts(discussionId, nearNumber) {
    if (!nearNumber) return Promise.resolve(null);
    return app.store.find('posts', {
      filter: {
        discussion: discussionId
      },
      page: {
        near: nearNumber
      },
      include: 'user,user.groups,editedUser'
    });
  }

  /**
   * Show blog post
   */
  show(article) {
    this.article = article;
    app.setTitle("".concat(article.title(), " - ").concat(app.translator.trans('v17development-flarum-blog.forum.blog')));
    this.loading = false;
    this.stream = new PostStreamState(article);
    app.current.set('discussion', article);
    app.current.set('stream', this.stream);
    if (app.session.user && !article.lastReadPostNumber()) {
      article.save({
        lastReadPostNumber: 1
      });
    }
    const discussionId = article.id();

    // BLOG: a cikk #1, kommentek #2-től
    const fallbackNear = 1;

    // ha nincs near az URL-ben, akkor is induljon komment preload
    const target = this.near || fallbackNear;

    // csak akkor "ugrunk", ha az URL-ben tényleg volt near
    const shouldJump = !!this.near;
    const go = () => new Promise(resolve => {
      // biztosítsuk, hogy a PostStream már mountolódott
      setTimeout(resolve, 0);
    }).then(() => this.stream.goToNumber(target, shouldJump)).then(() => m.redraw()).catch(() => m.redraw());

    // preload (Ctrl+F5 ellen) -> utána goToNumber
    this.preloadNearPosts(discussionId, target).then(go).catch(go);
    m.redraw();
  }
  postItems() {
    var _this$article2, _this$article2$title, _this$article3, _this$article3$isHidd;
    let articlePost = null;
    if (!this.loading && this.article) {
      var _this$article, _this$article$firstPo;
      articlePost = (_this$article = this.article) == null || (_this$article$firstPo = _this$article.firstPost) == null ? void 0 : _this$article$firstPo.call(_this$article);
    }
    const items = new ItemList();
    items.add('title', m("h1", {
      className: classList('FlarumBlog-Article-Title', {
        'FlarumBlog-Article-GhostTitle': this.loading
      })
    }, (this == null || (_this$article2 = this.article) == null || (_this$article2$title = _this$article2.title) == null ? void 0 : _this$article2$title.call(_this$article2)) || 'Ghost title', ((_this$article3 = this.article) == null || (_this$article3$isHidd = _this$article3.isHidden) == null ? void 0 : _this$article3$isHidd.call(_this$article3)) && "(".concat(app.translator.trans('v17development-flarum-blog.forum.hidden'), ")")), 100);
    items.add('publishDate', m("div", {
      className: classList('FlarumBlog-Article-PublishDate', {
        'FlarumBlog-Article-GhostPublishDate': this.loading
      })
    }, this.article ? fullTime(this.article.createdAt()) : m("span", null, "\xA0")), 80);
    if (this.loading) {
      items.add('skeleton', [0, 1, 2].map(() => m("div", null, m("p", {
        className: 'FlarumBlog-Article-GhostParagraph'
      }, "\xA0"), m("p", {
        className: 'FlarumBlog-Article-GhostParagraph'
      }, "\xA0"), m("p", {
        className: 'FlarumBlog-Article-GhostParagraph'
      }, "\xA0"), m("p", null, "\xA0"))), 60);
    }
    if (!this.loading) {
      var _this$article$blogMet, _this$article4, _this$article$blogMet2;
      if ((_this$article$blogMet = (_this$article4 = this.article).blogMeta) != null && (_this$article$blogMet = _this$article$blogMet.call(_this$article4)) != null && (_this$article$blogMet2 = _this$article$blogMet.isPendingReview) != null && _this$article$blogMet2.call(_this$article$blogMet)) {
        items.add('review', m("div", {
          className: 'Post-body'
        }, m("blockquote", {
          class: "uncited",
          style: {
            fontSize: '16px'
          }
        }, m("div", null, icon('far fa-clock', {
          style: {
            marginRight: '5px'
          }
        }), ' ', app.translator.trans('v17development-flarum-blog.forum.review_article.pending_review')))), 60);
      }
      if (articlePost) {
        items.add('post', m(CommentPost, {
          post: articlePost
        }), 40);
      }
    }
    return items;
  }
  contentItems() {
    var _this$article5, _this$article5$featur, _this$article6, _this$article6$isHidd, _app$session$user, _app$session$user$can, _this$article7, _this$article7$canRen, _this$article8, _this$article8$posts, _this$article8$posts$, _this$article9, _this$article9$tags;
    const defaultImage = app.forum.attribute('blogDefaultImage') ? "url(".concat(app.forum.attribute('baseUrl'), "/assets/").concat(app.forum.attribute('blogDefaultImage'), ")") : null;
    const blogImage = (_this$article5 = this.article) != null && (_this$article5 = _this$article5.blogMeta()) != null && (_this$article5$featur = _this$article5.featuredImage) != null && _this$article5$featur.call(_this$article5) ? "url(".concat(this.article.blogMeta().featuredImage(), ")") : defaultImage;
    const items = new ItemList();
    items.add('image', m("div", {
      className: classList('FlarumBlog-Article-Image FlarumBlog-default-image', {
        'FlarumBlog-Article-GhostImage': this.loading
      }),
      style: {
        backgroundImage: blogImage,
        opacity: (_this$article6 = this.article) != null && (_this$article6$isHidd = _this$article6.isHidden) != null && _this$article6$isHidd.call(_this$article6) ? 0.4 : null
      }
    }), 100);
    if (this.article && ((_app$session$user = app.session.user) != null && (_app$session$user$can = _app$session$user.canEdit) != null && _app$session$user$can.call(_app$session$user) || (_this$article7 = this.article) != null && (_this$article7$canRen = _this$article7.canRename) != null && _this$article7$canRen.call(_this$article7) || (_this$article8 = this.article) != null && (_this$article8$posts = _this$article8.posts) != null && (_this$article8$posts = _this$article8$posts.call(_this$article8)) != null && (_this$article8$posts = _this$article8$posts[0]) != null && (_this$article8$posts$ = _this$article8$posts.canEdit) != null && _this$article8$posts$.call(_this$article8$posts))) {
      items.add('editArticle', m(BlogPostController, {
        article: this.article
      }), 80);
    }
    items.add('categories', m("div", {
      className: "FlarumBlog-Article-Categories"
    }, !this.loading && ((_this$article9 = this.article) == null || (_this$article9$tags = _this$article9.tags) == null || (_this$article9$tags = _this$article9$tags.call(_this$article9)) == null ? void 0 : _this$article9$tags.map(tag => m(Link, {
      href: app.route('blogCategory', {
        slug: tag.slug()
      })
    }, tag.name()))), this.loading && [0, 1].map(() => m("span", {
      className: "FlarumBlog-Article-GhostCategory"
    }, "Category"))), 60);
    items.add('post', m("div", {
      className: 'FlarumBlog-Article-Post'
    }, this.postItems().toArray()), 40);
    return items;
  }
  articleItems() {
    var _this$article0, _this$article0$isLock, _this$article1, _this$article1$commen;
    const items = new ItemList();
    items.add('content', m("div", {
      className: "FlarumBlog-Article-Content"
    }, this.contentItems().toArray()), 100);
    if (!(this != null && (_this$article0 = this.article) != null && (_this$article0$isLock = _this$article0.isLocked) != null && _this$article0$isLock.call(_this$article0) && (this == null || (_this$article1 = this.article) == null || (_this$article1$commen = _this$article1.commentCount) == null ? void 0 : _this$article1$commen.call(_this$article1)) === 1)) {
      var _this$article10, _this$article10$isLoc;
      items.add('comments', m("div", {
        className: 'FlarumBlog-Article-Comments'
      }, !this.loading && app.session.user && this.article.subscription && (!this.article.isLocked || this.article.isLocked && !this.article.isLocked()) && m(ArticleSubscription, {
        discussion: this.article
      }), m("h4", null, app.translator.trans('v17development-flarum-blog.forum.comment_section.comments'), " (", this.article ? this.article.commentCount() - 1 : 0, ")"), !this.loading && ((_this$article10 = this.article) == null || (_this$article10$isLoc = _this$article10.isLocked) == null ? void 0 : _this$article10$isLoc.call(_this$article10)) && m("div", {
        className: 'Post-body'
      }, m("blockquote", {
        class: "uncited"
      }, m("div", null, m("span", {
        className: 'far fa-lock',
        style: {
          marginRight: '5px'
        }
      }), ' ', app.translator.trans('v17development-flarum-blog.forum.comment_section.locked')))), !this.loading && this.article && this.PostStream && m(this.PostStream, {
        discussion: this.article,
        stream: this.stream,
        onPositionChange: this.positionChanged.bind(this)
      })), 75);
    }
    return items;
  }
  view() {
    return [app.forum.attribute('blogAddHero') == true && IndexPage.prototype.hero(), m("div", {
      className: 'FlarumBlogItem'
    }, m("div", {
      className: 'container'
    }, m("div", {
      className: 'FlarumBlog-ToolButtons'
    }, m(Link, {
      href: app.route('blog'),
      className: 'Button',
      onclick: e => {
        if (app.previous.matches(BlogOverview)) {
          e.preventDefault();
          history.back();
        }
      }
    }, m("i", {
      class: "icon fas fa-angle-left Button-icon"
    }), m("span", {
      class: "Button-label"
    }, app.translator.trans('v17development-flarum-blog.forum.return_to_overview')))), m("div", {
      className: 'FlarumBlog-Article'
    }, m("div", {
      className: 'FlarumBlog-Article-Container'
    }, this.articleItems().toArray()), m(BlogItemSidebar, {
      article: this.article,
      loading: this.loading
    }))))];
  }
  positionChanged(startNumber, endNumber) {
    const article = this.article;
    if (app.session.user && endNumber > (article.lastReadPostNumber() || 0)) {
      article.save({
        lastReadPostNumber: endNumber
      });
      m.redraw();
    }
  }
}
flarum.reg.add('v17development-blog', 'forum/pages/BlogItem', BlogItem);